import { ModelBase } from 'store/model-base';

export class CmsEsimActivation extends ModelBase {
    public static storeName: string = 'cmsEsimActivation';

    public progressBar: ActivationProgressBar;
    public deferredPortingProgressBar: ActivationProgressBar;
    public getStarted: ActivationGetStarted;
    public chooseNumber: ActivationChooseNumber;
    public portingForm: ActivationPortingForm;
    public deferredPortingPortingForm: ActivationPortingForm;
    public inProgress: ActivationInProgress;
    public deferredPortingInProgress: ActivationInProgress;
    public trigger: ActivationTrigger;
    public error: ActivationError;
    public deferredPortingError: DeferredPortingError;
    public deferredPortingRcodeError: DeferredPortingError;
    public otpError: ActivationOtpError;
    public tooManyAttemptsError: ActivationOtpError;
    public confirmation: ActivationConfirmation;
    public deferredPortingConfirmation: ActivationConfirmation;
    public byodBase: ByodActivationBase;
    public byodtrigger: ByodActivationTriggerContent;
    public byodSplash: ByodActivationSplashContent;
    public byodGetStarted: ByodActivationGetStartedContent;
    public byodPort: ByodActivationPort;
    public byodChoose: ByodActivationChoose;
    public byodActivationErrors: ByodActivationErrorsContent;
    public byodActivateSim: ByodActivationActivateSimContent;
    public byodInsertSim: ByodActivationInsertSim;
    public byodConfirmation: ByodActivationConfirmationContent;
    public byodActivationFailed: ByodActivationFailedContent;
    public byodActivationMobileWarning: ByodActivationMobileWarningContent;
    public byodActivationBreadcrumbs: ByodActivationBreadcrumb[];
    public byodActivationUnlockInstructions: ByodActivationUnlockInstructions;
    public manualDownloadModal: EsimDownloadModalData;
    public galaxyManualDownloadModal: EsimDownloadModalData;
    public pixelManualDownloadModal: EsimDownloadModalData;
    public motorolaManualDownloadModal: EsimDownloadModalData;
    public activationLocked: ActivationLocked;
    public ndelUpgradeConfirmation: ActivationConfirmation;
    public fccGetStarted: FccActivationGetStarted;
    public fccGetStartedCbm: FccActivationGetStartedCbm;
    public deferredPortingStarted: FccActivationGetStartedCbm;
    public cmsPostActivationError: CmsPostActivationError[];
}
